// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Avatar_wrapper__2m2ID","photo":"Avatar_photo__2Ef8u","userName":"Avatar_userName__2QerL","initials":"Avatar_initials__KMufy"};